module.exports = __webpack_public_path__ + "img/Feature.ce4be5f9.jpg";